import { useMutation } from '@tanstack/react-query';
import {
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Layout,
  MenuProps,
  Modal,
  Radio,
  Row,
  Space,
  Spin,
  Typography,
} from 'antd';
import { FormInstance, useForm } from 'antd/es/form/Form';
import FormItem from 'antd/es/form/FormItem';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import {
  ChangeEvent,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';

import { CustomerApis, IGetCustomerParams } from 'apis/CustomerApis';
import {
  ICreateDealPrice,
  IGetOrederIdCbx,
  IGetPurchaseInvoice,
  IPrintFile,
  ISapPurchaseOrder,
  IUpdateOrderParams,
  IUpdatePurchaseOrderForAcountant,
  SaveOrderParams,
} from 'apis/GraphQL/Variables/purchaseInvoice';
import { PurChaseInvoiceApi } from 'apis/PurchaseInvoiceApis';
import { Split } from 'assets/svg';
import { Button, InputForm, SelectForm } from 'components';
import MigoDetailModal from '../PurchaseInvoiceDetailPage/components/MigoDetailModal';
import { ExportOptionsButton } from 'components/Button/ExportOptionsButton';
import { Collapse, Panel } from 'components/Collapse/Collapse';
import { OptionsMenu } from 'components/OptionsMenu/OptionsMenu';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { useTitle } from 'contexts/TitleProvider';
import { useUser } from 'contexts/UserProvider';
import useQueryParam from 'hooks/useQueryPrams';
import {
  CustomerList,
  CustomerType,
  SavePurchaseOrder,
} from 'interfaces/PurchaseInvoice/AddPurchaseInvoice';
import {
  ApiResponse,
  ComboBoxOption,
} from 'pages/Product/ProductSloc/FilterProductSloc';
import path from 'routes/Path';
import formatNumber, {
  convertDateToBE,
  formatCurrency,
  toastError,
  toastSuccess,
  useDebouncedCallback,
} from 'utils/constants/functions';
import { IPriceDetail } from '../PurchaseInvoiceDetailPage/PurchaseInvoiceDetailPage';
import TableAddPurchaseInvoice from './TableAddPurchaseInvoice';
import { icons } from 'utils/constants/icons';

const colSpan = 8;
const { Text } = Typography;

interface IMarketGoldPrice {
  id: string;
  salePrice: number;
}

interface IMarketGoldPriceApproval {
  salePrice: number;
  dealPrice: number;
  note: string;
  status: string;
  statusId: string;
  usePolicyPrice: boolean;
}

interface INoteForm {
  note: string;
}

interface ICustomerForm {
  customerId: string;
  storeName: string;
  trankName: string;
  taxId: string;
  mainCustomerId: string;
  phone: string;
  address: string;
}

interface IPurchaseInvoiceForm {
  purchaseType: string;
  documentType: string;
  policyType: string;
  unit: string;
  typeCustomer: string;
  purchaseCustomerId: string;
  orderIds: string[];
  q10Surplus: string;
}

interface IPriceNegotationForm {
  currentMarketGoldPrice: string;
  marketGoldPriceNegotation: string;
  note: string;
  usePolicyPrice: boolean;
}

interface IOrderTempItem {
  id: string | number;
  name: string | number;
  marketGoldPrice: number;
}

interface IUpdatePurchaseOrderParams {
  record?: any[];
  marketGoldPrice?: any;
}

const AddPurchaseInvoice = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const queryParams = useQueryParam();
  const { setBreadcrumb, setTitle } = useTitle();
  const { PlusOutlined } = icons;

  const purchaseOrderId = queryParams.get('id');

  const [noteForm] = useForm<INoteForm>();
  const [customerForm] = useForm<ICustomerForm>();
  const [priceNegotationForm] = useForm<IPriceNegotationForm>();
  const [purchaseInvoiceForm] = useForm<IPurchaseInvoiceForm>();

  // {
  //   purchaseType: '811',
  //   documentType: 'Z01',
  //   policyType: 'PY100_01',
  //   unit: 'PY101_01',
  //   q10Surplus: '1',
  //   typeCustomer: 'CT100_01',
  // }

  const purchaseType = Form.useWatch('purchaseType', purchaseInvoiceForm);
  const selectedValue = Form.useWatch('purchaseOrders', purchaseInvoiceForm);

  const [editIndex, setEditIndex] = useState({
    index: -1,
    type: '',
  });

  const [tableData, setTableData] = useState<any>([]);

  const [isOpenCustomerModal, setIsOpenCustomerModal] = useState(false);
  const [isOpenPriceNegotiation, setIsOpenPriceNegotiation] = useState(false);
  const [purchaseInvoiceStatus, setPurchaseInvoiceStatus] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState<any>();
  const [selectedPurchaseCustomer, setSelectedPurchaseCustomer] =
    useState<any>();

  const [orderTempId, setOrderTempId] = useState<IOrderTempItem[]>([]);
  const [typePurchase, setTypePurchase] = useState<ComboBoxOption[]>([]);
  const [unitPurchase, setUnitPurchase] = useState<ComboBoxOption[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<IOrderTempItem[]>([]);
  const [typePolicyPurchase, setTypePolicyPurchase] = useState<
    ComboBoxOption[]
  >([]);
  const [typeOfDocPurchase, setTypeOfDocPurchase] = useState<ComboBoxOption[]>(
    [],
  );

  const [customerData, setCustomerData] = useState<CustomerList[]>();
  const [typeCustomer, setTypeCustomer] = useState<CustomerType[]>();
  const [marketGoldPrice, setMarketGoldPrice] = useState<IMarketGoldPrice>();
  const [marketGoldPriceApproval, setMarketGoldPriceApproval] =
    useState<IMarketGoldPriceApproval>();

  const [customers, setCustomers] =
    useState<ILazySelectData>(initLazySelectData);
  const [processData, setProcessData] = useState<any[]>([]);
  const [lastItem, setLastItem] = useState<any>(null);
  const [purchaseOrderData, setPurchaseOrderData] =
    useState<SavePurchaseOrder>();
  const [isCreatingMigo, setIsCreatingMigo] = useState(false);
  const [migoNumber, setMigoNumber] = useState<string>('');
  const [showMigoDetail, setShowMigoDetail] = useState(false);
  const [lastProcessType, setLastProcessType] = useState<string>('');

  // Debug log để kiểm tra migoNumber
  console.log('Current migoNumber:', migoNumber);

  // Load process data khi có purchaseOrderData
  const loadProcessData = useCallback(() => {
    if (purchaseOrderData?.id) {
      PurChaseInvoiceApi.getPurchaseOrderProcess({
        purchaseOrderId: purchaseOrderData.id,
        status: false,
      })
        .then((processRes) => {
          console.log('Load process data:', processRes);
          const processDataFromApi =
            processRes?.data?.getPurchaseOrderProcces?.data;
          console.log('processData:', processDataFromApi);
          setProcessData(processDataFromApi || []);
          if (processDataFromApi && processDataFromApi.length > 0) {
            // Lọc ra những item có status = true
            const filteredData = processDataFromApi.filter(
              (item: any) => item.status === true,
            );
            // Lấy item cuối cùng từ danh sách đã lọc
            const lastItemFromApi = filteredData[filteredData.length - 1];
            setLastItem(lastItemFromApi);
            console.log('lastItem:', lastItemFromApi);
            console.log('Debug lastItem values:', {
              status: lastItemFromApi?.status,
              statusType: typeof lastItemFromApi?.status,
              processType: lastItemFromApi?.processType,
              processTypeType: typeof lastItemFromApi?.processType,
            });

            let migoDisplay = '- / _';

            if (lastItemFromApi?.processType === '501') {
              // processType = 501: hiển thị processCode / trống
              migoDisplay = `${lastItemFromApi.processCode} / _`;
            } else if (lastItemFromApi?.processType === '502') {
              // processType = 502: hiển thị processCode / processCode
              migoDisplay = `${lastItemFromApi.processCode} / ${lastItemFromApi.processCode}`;
            } else if (processDataFromApi.length >= 2) {
              // Có cả 501 và 502: hiển thị item cuối - 1 / item cuối
              const secondLastItem =
                processDataFromApi[processDataFromApi.length - 2];
              migoDisplay = `${secondLastItem.processCode} / ${lastItemFromApi.processCode}`;
            }

            console.log('migoDisplay:', migoDisplay);
            setMigoNumber(migoDisplay);

            // Lưu processType của item cuối cùng
            setLastProcessType(lastItemFromApi?.processType || '');
          }
        })
        .catch((error) => {
          console.error('Load process error:', error);
        });
    }
  }, [purchaseOrderData?.id]);

  // console.log('customers', customers);
  // console.log('customerData', customerData);
  // console.log('filteredOptions', filteredOptions);
  // console.log('formattedItems', orderTempId);
  // console.log('selectedCustomer', selectedCustomer);
  // console.log('selectedPurchaseCustomer', selectedPurchaseCustomer);
  // console.log('customerData', customerData);
  // console.log('dealPrice', dealPrice);
  // console.log('marketGoldPriceApproval', marketGoldPriceApproval);

  const isAccountantDisableEdit = useMemo(
    () =>
      !!purchaseOrderData?.parentId ||
      !(user?.isAccountant || user?.isStorekeeper || user?.isKTD) ||
      purchaseOrderData?.statusId === 'OR02_02' ||
      user?.id !== purchaseOrderData?.createId,
    [user, purchaseOrderData],
  );

  const finalPrice = purchaseOrderData?.tpurchaseDetails?.reduce(
    (acc, { finalPriceAccounting, finalPrice }) => {
      acc += finalPriceAccounting ? finalPriceAccounting : finalPrice;
      return acc;
    },
    0,
  );

  const {
    mutate: getTypePurchaseInvoice,
    isPending: isgetTypePurchaseInvoicePending,
  } = useMutation({
    mutationFn: () => PurChaseInvoiceApi.getTypePurchase(),
    onSuccess: (res: ApiResponse<{ id: string; name: string }>) =>
      setTypePurchase(
        res.data.getCode.items
          ? res.data.getCode.items
              .filter((item) => item.id !== '501B')
              .map((item) => ({
                value: item.id,
                label: `${item.id} - ${item.name}`,
              }))
          : [],
      ),
  });

  const { mutate: getOrderTempIdCbx, isPending: isGetOrderTempIdCbxPending } =
    useMutation({
      mutationFn: (params: IGetOrederIdCbx) =>
        PurChaseInvoiceApi.getOrderTempIdCbx(params),
      onSuccess: (res) => {
        const items = res.data.getIewSpecificOrderId.items || [];
        const formattedItems = items.map((item: IOrderTempItem) => ({
          ...item,
          value: item.id,
          label: item.id,
          marketGoldPrice: item.marketGoldPrice,
        }));

        setOrderTempId(formattedItems);
        setFilteredOptions(formattedItems);
      },
    });

  const {
    mutate: getUnitPurchaseInvoice,
    isPending: isGetUnitPurchaseInvoicePending,
  } = useMutation({
    mutationFn: () => PurChaseInvoiceApi.getUnitPurchase(),
    onSuccess: (res: ApiResponse<{ id: string; name: string }>) =>
      setUnitPurchase(
        res.data.getCode.items
          ? res.data.getCode.items.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          : [],
      ),
  });

  const {
    mutate: getTypePolicyPurchaseInvoice,
    isPending: isGetTypePolicyPurchaseInvoicePending,
  } = useMutation({
    mutationFn: () => PurChaseInvoiceApi.getTypePolicyPurchase(),
    onSuccess: (res: ApiResponse<{ id: string; name: string }>) =>
      setTypePolicyPurchase(
        res.data.getCode.items
          ? res.data.getCode.items.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          : [],
      ),
  });

  const {
    mutate: getTypeOfDocPurchaseInvoice,
    isPending: isGetTypeOfDocPurchaseInvoicePending,
  } = useMutation({
    mutationFn: () => PurChaseInvoiceApi.getTypeOfDocPurchase(),
    onSuccess: (res: ApiResponse<{ id: string; name: string }>) =>
      setTypeOfDocPurchase(
        res.data.getCode.items
          ? res.data.getCode.items.map((item) => ({
              value: item.id,
              label: `${item.id} - ${item.name}`,
            }))
          : [],
      ),
  });

  const { mutate: getTypeCustomer, isPending: isGetTypeCustomerPending } =
    useMutation({
      mutationFn: () => PurChaseInvoiceApi.getTypeCustomer(),
      onSuccess: (res) => setTypeCustomer(res?.data?.getCode?.items),
    });

  const { mutate: getMarketGoldPrice } = useMutation({
    mutationFn: () =>
      PurChaseInvoiceApi.getMarketGoldPrice(convertDateToBE(dayjs())),
    onSuccess: (res) =>
      setMarketGoldPrice(res?.data?.getDataMarketGoldPrice?.items?.[0]),
  });

  const {
    data: customerList,
    mutate: getCustomers,
    isPending: isGetCustomersPending,
  } = useMutation({
    mutationFn: (params: IGetCustomerParams) =>
      CustomerApis.getCustomers(params),
    onSuccess: (res) => {
      const items = res?.data?.getCustomer?.items;

      setCustomers({
        options: items?.map((item: any) => ({
          label: `${item?.sapCustomerId} - ${item?.storeName}`,
          value: item?.id,
        })),
        totalItems: res?.data?.getCustomer?.pageInfo?.totalItems,
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutate: getPurchaseInvoiceById,
    isPending: isGetPurchaseInvoiceByIdPending,
  } = useMutation({
    mutationFn: (params: IGetPurchaseInvoice) =>
      PurChaseInvoiceApi.getPurchaseInvoiceById(params),
    onSuccess: (res: any, variables) => {
      // console.log(res);
      if (res?.errors?.length) {
        toastError(res?.errors?.[0]?.message);
        return;
      }

      const data = res?.data?.getPurchaseOrder?.data;
      const purchaseOrderData: SavePurchaseOrder = {
        id: data?.id,
        matDoc: data?.matDoc,
        matYear: data?.matYear,
        rematDoc: data?.rematDoc,
        rematYear: data?.rematYear,
        reivDoc: data?.reivDoc,
        reivYear: data?.reivYear,
        ivDoc: data?.ivDoc,
        ivYear: data?.ivYear,
        ivStatus: data?.ivStatus,
        poId: data?.poId,
        // ttId: null,
        statusId: data?.statusId,
        parentId: data?.parentId,
        purchaseType: data?.purchaseType,
        purchaseStatus: data?.purchaseStatus,
        marketGoldPriceId: data?.marketGoldPriceId,
        marketPrice: data?.marketPrice,
        dealPrice: data?.dealPrice,
        totalQ10Sell: data?.totalQ10Sell,
        totalQ10Buy: data?.totalQ10Buy,
        totalQ10Surplus: data?.totalQ10Surplus,
        tpurchaseOrderQ10: data?.tpurchaseOrderQ10,
        note: data?.note,
        createId: data?.tcreateUser?.id,
        custType: data?.tcustType?.id,
        customerId: data?.tcustomer?.id,
        customerCheckinId: data?.customerCheckinId,
        deductType: data?.deductType,
        docType: data?.tdocType?.id,
        policyType: data?.tpolicyType?.id,
        purchType: data?.tpurchType?.id,
        createDate: data?.createDate,
        modifyId: data?.tmodifyUser?.id,
        modifyDate: data?.modifyDate,
        tcreateUser: {
          fullName: data?.tcreateUser?.fullName,
        },
        tmodifyUser: {
          fullName: data?.tmodifyUser?.fullName,
        },
        tpurchaseDetails: data?.tpurchaseDetails,
        purchaseStatusName: data?.tpurchaseStatus.name,
        tpurchaseChilds: data?.tpurchaseChilds,
      };

      setPurchaseOrderData(purchaseOrderData);
      setSelectedCustomer(data?.tcustomer);
      setSelectedPurchaseCustomer(data?.tcustomer);

      if (variables?.state === 'complete') return;

      getCustomerList(data?.tcustomer?.id);
      getCustomers({
        pageSize: 10,
        value: data?.customerCheckinId,
      });
      getMarketGoldPriceApproval({ id: data?.id });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: postPurchaseOrder, isPending: isPostPurchaseOrderPending } =
    useMutation({
      mutationFn: (params: SaveOrderParams) =>
        PurChaseInvoiceApi.postPurchaseOrder(params),
      onSuccess: (res) => {
        // console.log('postPurchaseOrder', res);
        setPurchaseOrderData(res?.data?.savePurchaseOrder?.data);

        const purchaseOrderId = res?.data?.savePurchaseOrder?.data?.id;
        const { customerId } = customerForm.getFieldsValue();
        const { typeCustomer, unit, documentType, policyType, purchaseType } =
          purchaseInvoiceForm.getFieldsValue();

        if (
          !customerId ||
          !purchaseOrderId ||
          !selectedCustomer ||
          (selectedCustomer && !Object.keys(selectedCustomer).length)
        ) {
          toastError('Không tìm thấy thông tin khách hàng');
          return;
        }

        if (
          !marketGoldPrice ||
          (marketGoldPrice && !Object.keys(marketGoldPrice).length)
        )
          return toastError('Không tìm thấy giá bóng');

        const params: IUpdateOrderParams = {
          customerId: customerId,
          customerType: typeCustomer,
          dealPrice: null,
          deductType: unit,
          docType: documentType,
          marketGoldPriceId: marketGoldPrice?.id,
          marketPrice: marketGoldPrice?.salePrice,
          note: null,
          poId: null,
          policyType: policyType,
          purchaseOrderId: purchaseOrderId,
          purchaseOrderDetail: [],
          purchaseType: '',
          purchType: purchaseType,
          orderIds: [],
          q10Surplus: 1,
          usePolicyPrice: false,
          customerCheckinId: selectedCustomer?.id,
        };

        updatePurchaseOrder(params);
        navigate(`?id=${purchaseOrderId}`);
      },
    });

  const {
    mutate: updatePurchaseOrder,
    isPending: isUpdatePurchaseOrderPending,
  } = useMutation({
    mutationFn: (params: IUpdateOrderParams) =>
      PurChaseInvoiceApi.updatePurchaseOrder(params),
    onSuccess: (res: any) => {
      if (res?.errors?.length) {
        toastError(res?.errors?.[0]?.message || 'Có lỗi xảy ra');
        return;
      }

      if (!res?.data?.savePurchaseOrder?.data) {
        toastError(res?.data?.savePurchaseOrder?.message);
        return;
      }

      setPurchaseOrderData(res?.data?.savePurchaseOrder?.data);
    },
    onError: (error: any) => {
      console.log(error);
    },
  });

  const { mutate: getCustomerList, isPending: isGetCustomerListPending } =
    useMutation({
      mutationFn: (id: string) => CustomerApis.getCustomerList(id),
      onSuccess: (res) => {
        const items = res?.data?.getCustomerList?.items;

        const isHasCustomers = !!items?.filter(
          (customer: any) => customer?.id === selectedCustomer?.id,
        )?.length;

        const isValid =
          isHasCustomers ||
          !selectedCustomer ||
          (selectedCustomer && !Object.keys(selectedCustomer)?.length);

        const customerData = isValid
          ? items
          : [selectedCustomer, ...items]?.filter(
              (customer, index, arr) =>
                arr?.findIndex((item) => item?.id === customer?.id) === index,
            );
        setCustomerData(customerData);
      },
    });

  const {
    mutate: completePurchaseOrder,
    isPending: isCompletePurchaseOrderPending,
  } = useMutation({
    mutationFn: (id: string) => PurChaseInvoiceApi.completePurchaseOrder(id),
    onSuccess: (res) => {
      if (res?.data?.completePurchaseOrder?.code === '200') {
        purchaseOrderId &&
          getPurchaseInvoiceById({ id: purchaseOrderId, state: 'complete' });
        toastSuccess(res?.data?.completePurchaseOrder?.message);
        return;
      }

      toastError(res?.data?.completePurchaseOrder?.message);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutate: getMarketGoldPriceApproval,
    isPending: isGetMarketGoldPriceApprovalPending,
  } = useMutation({
    mutationFn: ({ id }: { id: string; status?: string }) =>
      PurChaseInvoiceApi.getMarketGoldPriceApproval(id),
    onSuccess: (res, variables) => {
      // console.log(variables, res);
      setMarketGoldPriceApproval(res?.data?.getPurchaseApprovalData);

      // if (variables.status === 'update') {
      //   console.log(variables);

      //   handleUpdatePurchaseOrder({
      //     marketGoldPrice: res?.data?.getPurchaseApprovalData,
      //   });
      // }

      const data = res?.data?.getPurchaseApprovalData;
      if (
        data?.statusId === 'AP100_02' &&
        data?.dealPrice !== purchaseOrderData?.dealPrice
      )
        handleUpdatePurchaseOrder({
          marketGoldPrice: data,
        });
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: createDealPrice, isPending: isCreateDealPricePending } =
    useMutation({
      mutationFn: (params: ICreateDealPrice) =>
        PurChaseInvoiceApi.createDealPrice(params),
      onSuccess: (res) => {
        setIsOpenPriceNegotiation(false);

        getMarketGoldPriceApproval({
          id: purchaseOrderData?.id ?? '',
          status: 'update',
        });
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const {
    mutate: updatePurchaseOrderWeightForAccountant,
    isPending: isUpdatePurchaseOrderWeightForAccountantPending,
  } = useMutation({
    mutationFn: (params: IUpdatePurchaseOrderForAcountant) =>
      PurChaseInvoiceApi.updatePurchaseOrderWeightForAccountant(params),
    onSuccess: (res: any) => {
      if (res?.errors?.length) {
        toastError(res?.errors?.[0]?.message || 'Có lỗi xảy ra');
        return;
      }

      getPurchaseInvoiceById({ id: purchaseOrderData?.id });
      toastSuccess(res?.data?.updatePurchaseOrderWeightForAccounting?.message);
    },
    onError: (errors: any) => {
      console.log(errors);
      toastError(errors?.response?.data?.message || 'Có lỗi xảy ra');
    },
  });

  const { mutate: cancelPurchaseInvoiceSeparation } = useMutation({
    mutationFn: (id: string) =>
      PurChaseInvoiceApi.cancelPurchaseInvoiceSeparation(id),
    onSuccess: (res) => {
      if (res?.data?.cancelPurchaseOrderSeparation?.code === '200') {
        toastSuccess(res?.data?.cancelPurchaseOrderSeparation?.message);
        navigate(path.PURCHASE_INVOICE);
        return;
      }

      toastError(res?.data?.cancelPurchaseOrderSeparation?.message);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutate: createSapPurchaseOrder,
    isPending: isSapPurchaseOrderPending,
  } = useMutation({
    mutationFn: (params: ISapPurchaseOrder) =>
      PurChaseInvoiceApi.createSapPurchaseOrder(params),
    onSuccess: (res) => {
      console.log(res);
      toastSuccess(res?.data?.message || 'Tạo bảng kê dẻ thành công');
      purchaseOrderId &&
        getPurchaseInvoiceById({ id: purchaseOrderId, state: 'complete' });
    },
    onError: (errors: any) => {
      const results = errors?.response?.data['data']['headtoresult']['results'];
      const messages = results
        .map((item: any) => item?.Message)
        .filter((msg: any) => !!msg)
        .join('\n');
      toastError(
        (errors?.response?.data?.message || 'Có lỗi xảy ra') + '\n' + messages,
      );
    },
  });

  const {
    mutate: cancelSapPurchaseOrder,
    isPending: isSapCancelPurchaseOrderPending,
  } = useMutation({
    mutationFn: (params: ISapPurchaseOrder) =>
      PurChaseInvoiceApi.cancelSapPurchaseOrder(params),
    onSuccess: (res) => {
      console.log(res);
    },
    onError: (errors: any) => {
      console.log(errors);
      toastError(errors?.response?.data?.message || 'Có lỗi xảy ra');
    },
  });

  const { mutate: deletePurchase, isPending: isDeletePurchasePending } =
    useMutation({
      mutationFn: (id: string) => PurChaseInvoiceApi.deletePurchase(id),
      onSuccess: (res) => {
        if (res?.data?.deletePurchaseOrder?.code === '200') {
          setPurchaseInvoiceStatus(true);
          toastSuccess(res?.data?.deletePurchaseOrder?.message);
          navigate(path.PURCHASE_INVOICE);
          return;
        }

        toastError(res?.data?.deletePurchaseOrder?.message);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const { mutate: printFileMutate, isPending: isPrintFileMutatePending } =
    useMutation({
      mutationFn: (params: IPrintFile) => PurChaseInvoiceApi.printFile(params),
      onSuccess: (res: any, variables) => {
        try {
          if (variables?.type === 'print') {
            const url = window.URL.createObjectURL(
              new Blob([res], { type: `application/pdf` }),
            );

            const newTab = window.open(url, '_blank');

            if (newTab)
              newTab.onload = () => {
                newTab.print();
              };
            else
              toastError(
                'Không thể mở tab mới. Vui lòng kiểm tra trình duyệt chặn popup.',
              );

            return;
          }

          const type = variables.type === 'pdf' ? 'pdf' : 'xlsx';

          const url = window.URL.createObjectURL(
            new Blob([res], { type: `application/${type}` }),
          );

          const link = document.createElement('a');
          link.href = url;
          link.download = `Bảng_dẻ_${variables.id}.${type}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          toastError(`Lỗi khi xuất file ${variables.type}. ${error}`);
        }
      },
      onError: (error) => {
        toastError(`Lỗi. ${error?.message ?? error}`);
      },
    });

  const isPending =
    isPrintFileMutatePending ||
    isCreateDealPricePending ||
    isGetOrderTempIdCbxPending ||
    isPostPurchaseOrderPending ||
    isgetTypePurchaseInvoicePending ||
    isGetUnitPurchaseInvoicePending ||
    isGetTypePolicyPurchaseInvoicePending ||
    isGetPurchaseInvoiceByIdPending ||
    isGetTypeOfDocPurchaseInvoicePending ||
    isGetTypeCustomerPending ||
    isGetCustomersPending ||
    isUpdatePurchaseOrderPending ||
    isGetCustomerListPending ||
    isCompletePurchaseOrderPending ||
    isUpdatePurchaseOrderWeightForAccountantPending ||
    isDeletePurchasePending ||
    isSapPurchaseOrderPending ||
    isGetMarketGoldPriceApprovalPending;

  const handleDeletePurchase = (id: string) => {
    if (!id) return toastError('Không tìm thấy bảng dẻ');

    deletePurchase(id);
  };

  const handleGetInitData = () => {
    getTypeCustomer();
    getMarketGoldPrice();
    getTypePurchaseInvoice();
    getUnitPurchaseInvoice();
    getTypeOfDocPurchaseInvoice();
    getTypePolicyPurchaseInvoice();
  };

  useEffect(() => {
    // setIsOpenCustomerModal(!purchaseOrderId);
    if (!purchaseOrderId) {
      handleCreateNew();
    }
    if (!purchaseOrderId) return;

    getPurchaseInvoiceById({
      id: purchaseOrderId,
    });
  }, [purchaseOrderId]);

  // Load process data khi có purchaseOrderData
  useEffect(() => {
    if (purchaseOrderData?.id) {
      loadProcessData();
    }
  }, [purchaseOrderData?.id, loadProcessData]);

  // useEffect(() => {
  //   if (!marketGoldPriceApproval || marketGoldPriceApproval?.statusId === null)
  //     return;

  //   // console.log('marketGoldPriceApproval', marketGoldPriceApproval);
  //   // if(marketGoldPriceApproval?.usePolicyPrice === purchaseOrderData?.us)
  //   handleUpdatePurchaseOrder({});
  // }, [marketGoldPriceApproval]);

  useEffect(() => {
    const cutomerListItems = customerList?.data?.getCustomer?.items;
    if (!purchaseOrderId || !cutomerListItems?.length) return;

    const isHasCustomer = !!customerData?.filter(
      (item) => item?.id === selectedCustomer?.id,
    )?.length;

    setCustomerData((prev) =>
      isHasCustomer
        ? prev
        : [cutomerListItems?.[0], ...(prev || [])]?.filter(
            (customer, index, arr) =>
              arr?.findIndex((item) => item?.id === customer?.id) === index,
          ),
    );
  }, [purchaseOrderData, customerList, selectedCustomer]);

  useEffect(() => {
    const params: IGetOrederIdCbx = {
      createRole: 'kt',
      plantId: user?.plantCode,
      teamSalesId: user?.teamSales?.[0]?.id || undefined,
      customerId: selectedCustomer?.id || purchaseOrderData?.customerCheckinId,
    };

    getOrderTempIdCbx(params);
  }, [user, selectedCustomer, purchaseType]);

  useEffect(() => {
    if (!selectedValue) {
      setFilteredOptions(orderTempId);
      return;
    }

    const selectedItem = orderTempId.find((item) => item.id === selectedValue);
    if (selectedItem) {
      const filtered = orderTempId.filter(
        (item) => item.marketGoldPrice === selectedItem.marketGoldPrice,
      );
      setFilteredOptions(filtered);
    }
  }, [selectedValue, orderTempId]);

  useEffect(() => {
    setTitle('Kế toán/thủ quỹ');
    setBreadcrumb([
      { title: 'Kế toán/thủ quỹ' },
      { title: 'Bảng dẻ', href: path.PURCHASE_INVOICE },
      { title: 'Tạo mới bảng dẻ' },
    ]);

    handleGetInitData();
  }, []);

  useEffect(() => {
    if (!isOpenPriceNegotiation) return;

    priceNegotationForm.setFieldValue(
      'currentMarketGoldPrice',
      marketGoldPrice?.salePrice?.toLocaleString('vi-vn'),
    );
  }, [isOpenPriceNegotiation, priceNegotationForm, marketGoldPrice]);

  useEffect(() => {
    customerForm.setFieldsValue({
      customerId: selectedCustomer?.id,
      storeName: selectedCustomer?.storeName,
      trankName: selectedCustomer?.trank?.name,
      taxId: selectedCustomer?.taxId,
      phone: selectedCustomer?.phone,
      mainCustomerId: selectedCustomer?.mainCustomerId,
      address: selectedCustomer?.address,
    });
  }, [selectedCustomer, customerForm]);

  useEffect(() => {
    if (!purchaseOrderData?.id) return;

    if (
      !purchaseOrderData ||
      (purchaseOrderData && !Object.keys(purchaseOrderData).length)
    ) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    const tableData = purchaseOrderData?.tpurchaseDetails?.map((item: any) => ({
      ...item,
      tproductId: item?.tproduct?.id,
    }));

    // console.log('tableData', tableData);
    setTableData(tableData);

    purchaseInvoiceForm.setFieldsValue({
      purchaseType: purchaseOrderData?.purchType || '811',
      documentType: purchaseOrderData?.docType || 'Z01',
      policyType: purchaseOrderData?.policyType || 'PY100_01',
      unit: purchaseOrderData?.deductType || 'PY101_01',
      q10Surplus: purchaseOrderData?.totalQ10Surplus?.toString() || '1',
      orderIds:
        purchaseOrderData?.tpurchaseOrderQ10?.map(
          (item: any) => item?.torder?.id,
        ) || [],
      typeCustomer: purchaseOrderData?.custType || 'CT100_01',
      purchaseCustomerId: purchaseOrderData?.customerId,
    });

    noteForm.setFieldValue('note', purchaseOrderData?.note);

    setEditIndex({
      index: -1,
      type: '',
    });
  }, [purchaseOrderData]);

  const menuProps: MenuProps = useMemo(() => {
    return {
      items: [
        {
          key: '1',
          label: 'Xuất excel',
          onClick: () => {
            purchaseOrderId &&
              printFileMutate({ id: purchaseOrderId, type: 'excel' });
          },
        },
        {
          key: '2',
          label: 'Xuất PDF',
          onClick: () => {
            purchaseOrderId &&
              printFileMutate({ id: purchaseOrderId, type: 'pdf' });
          },
        },
        {
          key: '3',
          label: 'In',
          onClick: () => {
            purchaseOrderId &&
              printFileMutate({ id: purchaseOrderId, type: 'print' });
          },
        },
      ],
    };
  }, [purchaseOrderId]);

  const optionMenuProps = useMemo(() => {
    const items = [
      {
        key: '1',
        danger: true,
        disabled: purchaseOrderData?.statusId !== 'OR02_02',
        label: <p className="w-full text-right">Huỷ tách</p>,
        onClick: () =>
          cancelPurchaseInvoiceSeparation(String(purchaseOrderData?.id)),
      },
      {
        key: '2',
        danger: true,
        disabled:
          !!purchaseOrderData?.parentId ||
          purchaseOrderData?.statusId === 'OR02_02' ||
          user?.id !== purchaseOrderData?.createId,
        label: <p className="w-full text-right">Xóa bảng dẻ</p>,
        onClick: () => handleDeletePurchase(String(purchaseOrderData?.id)),
      },
    ];

    // Thêm menu "Xuất kho tạm SAP" nếu đã có MIGO nhập và item cuối không phải 502
    // if (migoNumber && migoNumber !== '- / _' && lastProcessType !== '502') {
    //   items.push({
    //     key: '3',
    //     danger: false,
    //     disabled: isCreatingMigo,
    //     label: (
    //       <p className="w-full text-right">
    //         {isCreatingMigo ? 'Đang xuất kho...' : 'Xuất kho tạm SAP'}
    //       </p>
    //     ),
    //     onClick: () => {
    //       if (purchaseOrderData?.id) {
    //         setIsCreatingMigo(true);
    //         PurChaseInvoiceApi.createMigo({
    //           purchaseOrderId: purchaseOrderData.id,
    //           migoType: '502',
    //         })
    //           .then((res) => {
    //             console.log('Create MIGO export success:', res);
    //             toastSuccess('Xuất kho tạm SAP thành công');
    //             // Gọi API process để cập nhật MIGO
    //             return PurChaseInvoiceApi.getPurchaseOrderProcess({
    //               purchaseOrderId: purchaseOrderData.id,
    //               status: false,
    //             });
    //           })
    //           .then((processRes) => {
    //             console.log('Process data after export:', processRes);
    //             const processData =
    //               processRes?.data?.getPurchaseOrderProcces?.data;
    //             if (processData && processData.length > 0) {
    //               const lastItem = processData[processData.length - 1];
    //               let migoDisplay = '- / _';

    //               if (lastItem?.processType === '501') {
    //                 migoDisplay = `${lastItem.processCode} / _`;
    //               } else if (lastItem?.processType === '502') {
    //                 migoDisplay = `${lastItem.processCode} / ${lastItem.processCode}`;
    //               } else if (processData.length >= 2) {
    //                 const secondLastItem = processData[processData.length - 2];
    //                 migoDisplay = `${secondLastItem.processCode} / ${lastItem.processCode}`;
    //               }

    //               setMigoNumber(migoDisplay);

    //               // Lưu processType của item cuối cùng
    //               setLastProcessType(lastItem?.processType || '');

    //               // Reload process data để cập nhật trạng thái nút
    //               loadProcessData();
    //             }
    //           })
    //           .catch((error) => {
    //             console.error('Create MIGO export error:', error);
    //             toastError('Có lỗi xảy ra khi xuất kho tạm SAP');
    //           })
    //           .finally(() => {
    //             setIsCreatingMigo(false);
    //           });
    //       }
    //     },
    //   });
    // }

    return { items } as MenuProps;
  }, [purchaseOrderData, migoNumber, isCreatingMigo, lastProcessType]);

  const priceDetails: IPriceDetail[] = useMemo(
    () => [
      {
        key: 1,
        label: 'Giá bóng hiện tại',
        value: marketGoldPrice?.salePrice || '-',
      },
      {
        key: 2,
        label: 'Giá bóng',
        value: purchaseOrderData?.marketPrice || '-',
      },
      {
        key: 3,
        label: 'Giá thoả thuận',
        value: marketGoldPriceApproval?.dealPrice || '-',
      },
      { key: 5, label: 'Ghi chú', value: null },
      { key: 6, label: 'Thời gian', value: null },
      { key: 7, label: 'Người duyệt', value: null },
      {
        key: 8,
        label: 'Trạng thái',
        className:
          marketGoldPriceApproval?.statusId === 'AP100_02'
            ? 'text-green-500'
            : 'text-blue-500',
        value: marketGoldPriceApproval?.status,
      },
    ],
    [marketGoldPrice, purchaseOrderData, marketGoldPriceApproval],
  );

  const handleRenderValue = useCallback(
    (value: ReactNode) =>
      value ? (typeof value === 'number' ? formatNumber(value) : value) : '-',
    [],
  );

  const handleScrollCustomersChange = useCallback(
    (params: ILazySelectParams) => {
      const { pageSize, value } = params;

      getCustomers({
        pageSize,
        value,
      });
    },
    [],
  );

  const handleCustomerSelect = (value: any) => {
    const selectedCustomer = customerList?.data?.getCustomer?.items?.find(
      (customer: any) => customer?.id === value,
    );
    setSelectedCustomer(selectedCustomer);
  };

  const handlePurchaseCustomerSelect = (value: any) => {
    const selectedPurchaseCustomer = customerData?.find(
      (customer: any) => customer?.id === value,
    );

    if (
      !selectedPurchaseCustomer ||
      (selectedPurchaseCustomer &&
        !Object.keys(selectedPurchaseCustomer).length)
    ) {
      toastError('Không tìm thấy thông tin khách hàng');
      return;
    }

    setSelectedPurchaseCustomer(selectedPurchaseCustomer);
    handleUpdatePurchaseOrder({});
  };

  const checkFormValidate = async (form: FormInstance) => {
    try {
      await form.validateFields();
      return true;
    } catch (error) {
      return false;
    }
  };

  const handleSubmitModal = async () => {
    if (!(await checkFormValidate(customerForm))) {
      customerForm.validateFields();
      return;
    }

    if (
      !marketGoldPrice ||
      (marketGoldPrice && !Object.keys(marketGoldPrice).length)
    )
      return toastError('Không tìm thấy giá bóng');

    const { customerId } = customerForm.getFieldsValue();
    const params: SaveOrderParams = {
      customerId: customerId,
      customerCheckinId: customerId,
      marketGoldPriceId: marketGoldPrice?.id,
      marketPrice: marketGoldPrice?.salePrice,
    };

    setSelectedPurchaseCustomer(selectedCustomer);
    purchaseInvoiceForm.setFieldValue('purchaseCustomerId', customerId);

    setIsOpenCustomerModal(false);

    postPurchaseOrder(params);
    getCustomerList(customerId);
  };

  const handleAddPurchaseInvoiceItem = () => {
    setEditIndex((prev) => ({ ...prev, index: 0 }));
    setTableData([{ id: Math.random() }, ...tableData]);
  };

  const handleDelPurchaseInvoiceItem = (data: any[]) => {
    handleUpdatePurchaseOrder({ record: data });
  };

  const handleUpdatePurchaseOrderDebounced = useDebouncedCallback(
    () => handleUpdatePurchaseOrder({}),
    500,
  );

  const handleUpdatePurchaseOrder = async ({
    record,
    marketGoldPrice,
  }: IUpdatePurchaseOrderParams) => {
    // console.log('record', record);

    if (!(await checkFormValidate(purchaseInvoiceForm))) {
      purchaseInvoiceForm.validateFields();
      return;
    }

    const formattedMarketGoldPrice = marketGoldPrice
      ? marketGoldPrice
      : marketGoldPriceApproval;

    const purchaseOrderId = purchaseOrderData?.id;
    const marketPrice = purchaseOrderData?.marketPrice;
    const marketGoldPriceId = purchaseOrderData?.marketGoldPriceId;
    const {
      unit,
      typeCustomer,
      documentType,
      policyType,
      q10Surplus,
      purchaseType,
      purchaseCustomerId,
      orderIds,
    } = purchaseInvoiceForm.getFieldsValue();

    if (!purchaseOrderId) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    const purchaseOrderDetail = Array.isArray(record)
      ? record.map((item: any) => ({
          ...(typeof item?.id === 'string' && {
            purchaseOrderDetailId: item?.id,
          }),
          productId: item?.tproductId,
          measureWeightThread: item?.measureWeightThread,
          lossWeightThread: item?.lossWeightThread,
          includeWeightThread: item?.includeWeightThread,
          sloc: item?.sloc,
        }))
      : tableData?.map((item: any) => ({
          ...(typeof item?.id === 'string' && {
            purchaseOrderDetailId: item?.id,
          }),
          productId: item?.tproductId,
          measureWeightThread: item?.measureWeightThread,
          lossWeightThread: item?.lossWeightThread,
          includeWeightThread: item?.includeWeightThread,
          sloc: item?.sloc,
        }));

    const params: IUpdateOrderParams = {
      customerId: purchaseCustomerId,
      customerType: typeCustomer,
      dealPrice:
        formattedMarketGoldPrice !== null &&
        formattedMarketGoldPrice?.statusId === 'AP100_02'
          ? formattedMarketGoldPrice?.dealPrice
          : null,
      deductType: unit,
      docType: documentType,
      note: noteForm.getFieldValue('note'),
      poId: null,
      policyType: policyType,
      purchaseOrderId: purchaseOrderId,
      purchaseOrderDetail: purchaseOrderDetail?.filter(
        (item: any) => !!item?.productId,
      ),
      marketGoldPriceId: marketGoldPriceId,
      marketPrice: marketPrice,
      purchaseType: '',
      purchType: purchaseType,
      orderIds: Array.isArray(orderIds) ? orderIds : [],
      q10Surplus: Number(q10Surplus),
      usePolicyPrice:
        purchaseType === '800'
          ? false
          : formattedMarketGoldPrice?.usePolicyPrice !== null &&
              formattedMarketGoldPrice?.statusId === 'AP100_02'
            ? formattedMarketGoldPrice?.usePolicyPrice
            : true,
      customerCheckinId:
        selectedCustomer?.id || purchaseOrderData?.customerCheckinId,
    };

    // console.log(params);
    updatePurchaseOrder(params);
  };

  const handleEditPurchaseInvoiceItem = (record: any) => {
    const value = record?.[0];

    if (!purchaseOrderData?.id) {
      toastError('Không tìm thấy thông tin dẻ');
      return;
    }

    const {
      id,
      lossWeightThreadAccounting,
      includeWeightThreadAccounting,
      measureWeightThreadAccounting,
      sloc,
    } = value;

    const params: IUpdatePurchaseOrderForAcountant = {
      purchaseOrderDetailId: id,
      purchaseOrderId: purchaseOrderData?.id,
      lossWeightThread: lossWeightThreadAccounting,
      includeWeightThread: includeWeightThreadAccounting,
      measureWeightThread: measureWeightThreadAccounting,
      sloc: sloc,
    };
    updatePurchaseOrderWeightForAccountant(params);
  };

  const onSave = async (record: any) => {
    if (!purchaseOrderData?.id || !purchaseOrderData?.customerId) {
      toastError('Không tìm thấy thông tin đơn hàng');
      return;
    }

    setTableData(record);
    setEditIndex((prev) => ({ ...prev, index: -1 }));

    handleUpdatePurchaseOrder({ record });
  };

  const handleCompletePurchaseOrder = () => {
    if (!purchaseOrderData?.id || !purchaseOrderId) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    completePurchaseOrder(purchaseOrderId || purchaseOrderData.id);
  };

  const handleMarketGoldPriceChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const formattedValue = Number(value.replace(/\D/g, ''));

    priceNegotationForm.setFieldValue(
      'marketGoldPriceNegotation',
      formattedValue.toLocaleString('vi-VN'),
    );
  };

  const handleCancelPriceNegotation = () => {
    priceNegotationForm.resetFields();
    setIsOpenPriceNegotiation(false);
  };

  const handlePriceNegotation = async (values: IPriceNegotationForm) => {
    if (!(await checkFormValidate(priceNegotationForm))) {
      priceNegotationForm.validateFields();
      return;
    }

    if (!purchaseOrderData?.id) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    const {
      note,
      usePolicyPrice,
      currentMarketGoldPrice,
      marketGoldPriceNegotation,
    } = values;

    const params: ICreateDealPrice = {
      note,
      usePolicyPrice,
      purchaseId: purchaseOrderData.id,
      salePrice: Number(currentMarketGoldPrice?.replace(/\D/g, '')),
      dealPrice: Number(marketGoldPriceNegotation?.replace(/\D/g, '')),
    };

    createDealPrice(params);
  };

  const handleCreateNew = () => {
    customerForm.resetFields();
    purchaseInvoiceForm.resetFields();
    priceNegotationForm.resetFields();

    purchaseInvoiceForm.setFieldsValue({
      purchaseType: '811',
      documentType: 'Z01',
      policyType: 'PY100_01',
      unit: 'PY101_01',
      q10Surplus: '1',
      typeCustomer: 'CT100_01',
    });

    setTableData([]);
    // setDealPrice(undefined);
    setSelectedCustomer(undefined);
    setSelectedPurchaseCustomer(undefined);

    setPurchaseInvoiceStatus(false);

    setOrderTempId([]);
    setTypePurchase([]);
    setUnitPurchase([]);
    setFilteredOptions([]);
    setTypePolicyPurchase([]);
    setTypeOfDocPurchase([]);

    setCustomerData(undefined);
    setTypeCustomer(undefined);
    setMarketGoldPrice(undefined);

    setCustomers(initLazySelectData);
    setPurchaseOrderData(undefined);

    setEditIndex({
      index: -1,
      type: '',
    });

    handleGetInitData();
    setIsOpenCustomerModal(true);
  };

  const handleSapPurchaseOrder = () => {
    if (!purchaseOrderData?.id) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    if (!user || (user && !Object.keys(user).length)) {
      toastError('Không tìm thấy thông tin user');
      return;
    }

    const params: ISapPurchaseOrder = {
      tranId: purchaseOrderData?.id,
      plant: user.plantCode,
    };
    createSapPurchaseOrder(params);
  };

  const handleCancelSapPurchaseOrder = () => {
    if (!purchaseOrderData?.id) {
      toastError('Không tìm thấy thông tin bảng dẻ');
      return;
    }

    if (!user || (user && !Object.keys(user).length)) {
      toastError('Không tìm thấy thông tin user');
      return;
    }

    const params: any = {
      tranId: purchaseOrderData?.id,
    };
    cancelSapPurchaseOrder(params);
  };

  const isProd = process.env.REACT_APP_API_BASE_URL?.includes('dms-api.pnj.io');

  return (
    <Spin spinning={isPending}>
      <Layout className="p-4 bg-transparent">
        <Row
          gutter={[8, 16]}
          align="middle"
          justify="space-between"
          className="mb-3"
        >
          <Col className="py-[2px] !px-4 bg-white rounded-[100px]">
            <span className="text-[#0077CC]">Trạng thái: </span>
            <span
              className={`${purchaseOrderData?.purchaseStatus === 'PUR00_01' ? 'text-green-500' : 'text-blue-500'} font-bold`}
            >
              {purchaseOrderData?.purchaseStatusName ?? '-'}
            </span>
          </Col>
          <Row gutter={[8, 8]} align="middle">
            {(user?.isAccountant || user?.isKTD) && (
              <Col>
                <Button
                  fill
                  title="Tạo mới"
                  handleOnclick={handleCreateNew}
                  // disabled={!user?.isAccountant}
                />
              </Col>
            )}
            {(user?.isAccountant || user?.isKTD) && (
              <Col>
                <Button
                  title="Lưu"
                  displayType="approve"
                  disabled={purchaseOrderData?.statusId === 'OR02_02'}
                  handleOnclick={handleCompletePurchaseOrder}
                />
              </Col>
            )}
            {/* {user?.isAccountant && purchaseType === '501B' && (
              <Col>
                <Button
                  fill
                  title={
                    isCreatingMigo ? 'Đang nhập kho...' : 'Nhập kho tạm SAP'
                  }
                  iconBefore={<PlusOutlined />}
                  disabled={
                    isCreatingMigo ||
                    Boolean(
                      migoNumber &&
                        migoNumber !== '- / _' &&
                        migoNumber !== '' &&
                        lastProcessType !== '502',
                    )
                  }
                  loading={isCreatingMigo}
                  handleOnclick={() => {
                    if (purchaseOrderData?.id) {
                      setIsCreatingMigo(true);
                      PurChaseInvoiceApi.createMigo({
                        purchaseOrderId: purchaseOrderData.id,
                        migoType: '501',
                      })
                        .then((res) => {
                          console.log('Create MIGO success:', res);
                          toastSuccess('Nhập kho tạm SAP thành công');
                          // Gọi API process sau khi tạo MIGO thành công
                          return PurChaseInvoiceApi.getPurchaseOrderProcess({
                            purchaseOrderId: purchaseOrderData.id,
                            status: false,
                          });
                        })
                        .then((processRes) => {
                          console.log('Process data:', processRes);
                          const processDataFromApi =
                            processRes?.data?.getPurchaseOrderProcces?.data;
                          console.log('processData:', processDataFromApi);

                          // Cập nhật processData và lastItem ngay lập tức
                          setProcessData(processDataFromApi || []);

                          if (
                            processDataFromApi &&
                            processDataFromApi.length > 0
                          ) {
                            // Lọc ra những item có status = true
                            const filteredData = processDataFromApi.filter(
                              (item: any) => item.status === true,
                            );
                            // Lấy item cuối cùng từ danh sách đã lọc
                            const lastItemFromApi =
                              filteredData[filteredData.length - 1];
                            setLastItem(lastItemFromApi);
                            console.log('lastItem updated:', lastItemFromApi);

                            let migoDisplay = '- / _';

                            if (lastItemFromApi?.processType === '501') {
                              // processType = 501: hiển thị processCode / trống
                              migoDisplay = `${lastItemFromApi.processCode} / _`;
                            } else if (lastItemFromApi?.processType === '502') {
                              // processType = 502: hiển thị processCode / processCode
                              migoDisplay = `${lastItemFromApi.processCode} / ${lastItemFromApi.processCode}`;
                            } else if (processDataFromApi.length >= 2) {
                              // Có cả 501 và 502: hiển thị item cuối - 1 / item cuối
                              const secondLastItem =
                                processDataFromApi[
                                  processDataFromApi.length - 2
                                ];
                              migoDisplay = `${secondLastItem.processCode} / ${lastItemFromApi.processCode}`;
                            }

                            console.log('migoDisplay:', migoDisplay);
                            setMigoNumber(migoDisplay);

                            // Lưu processType của item cuối cùng
                            setLastProcessType(
                              lastItemFromApi?.processType || '',
                            );

                            toastSuccess(
                              `Nhập kho tạm SAP thành công! Số MIGO: ${migoDisplay}`,
                            );
                          }
                        })
                        .catch((error) => {
                          console.error('Create MIGO or Process error:', error);
                          toastError('Có lỗi xảy ra khi nhập kho tạm SAP');
                        })
                        .finally(() => {
                          setIsCreatingMigo(false);
                        });
                    }
                  }}
                />
              </Col>
            )} */}
            {(user?.isAccountant || user?.isKTD) && (
              <Col>
                <Button
                  fill
                  title="Tách dẻ"
                  iconBefore={<Split />}
                  disabled={
                    !!purchaseOrderData?.parentId ||
                    purchaseOrderData?.statusId === 'OR02_02' ||
                    (marketGoldPriceApproval?.statusId
                      ? marketGoldPriceApproval?.statusId === 'AP100_01'
                      : false)
                  }
                  handleOnclick={() =>
                    navigate(path.SEPARATE_PURCHASE_INVOICE_DETAIL, {
                      state: {
                        id: purchaseOrderData?.id,
                        priceDetails,
                        purchaseDetail: purchaseOrderData?.tpurchaseDetails,
                      },
                    })
                  }
                />
              </Col>
            )}
            {(user?.isAccountant || user?.isKTD) && (
              <Col>
                <Button
                  fill
                  title="Thương lượng giá"
                  disabled={
                    // !!purchaseOrderData?.parentId ||
                    user?.id !== purchaseOrderData?.createId ||
                    purchaseOrderData?.statusId === 'OR02_02' ||
                    purchaseInvoiceForm.getFieldValue('purchaseType') ===
                      '800' ||
                    (marketGoldPriceApproval?.statusId
                      ? marketGoldPriceApproval?.statusId === 'AP100_01'
                      : false)
                  }
                  handleOnclick={() => setIsOpenPriceNegotiation(true)}
                />
              </Col>
            )}
            <Col>
              <Button
                fill
                title="Tạo PO"
                iconBefore={<PlusOutlined />}
                loading={isSapPurchaseOrderPending}
                disabled={
                  !(user?.isAccountant || user?.isKTD) ||
                  (purchaseOrderData?.tpurchaseChilds ?? []).length > 0 ||
                  // !!purchaseOrderData?.parentId ||
                  (marketGoldPriceApproval?.statusId &&
                    marketGoldPriceApproval?.statusId === 'AP100_01') ||
                  purchaseOrderData?.purchaseStatus === 'PUR00_01' ||
                  purchaseOrderData?.purchaseStatus === 'PUR00_03' ||
                  purchaseOrderData?.purchaseStatus === 'PUR00_04' ||
                  purchaseOrderData?.purchaseStatus === 'PUR00_05' ||
                  purchaseOrderData?.purchaseStatus === 'PUR00_06'
                }
                handleOnclick={handleSapPurchaseOrder}
              />
            </Col>
            <Col className="h-[43px]">
              <ExportOptionsButton menu={menuProps} />
            </Col>
            {(user?.isAccountant || user?.isKTD) && (
              <Col>
                <OptionsMenu
                  menu={optionMenuProps}
                  placement="bottomRight"
                  className="bg-white !p-2 border rounded-lg"
                />
              </Col>
            )}
          </Row>
        </Row>

        <div className="grid grid-cols-10 gap-6 mt-4">
          <div className="col-span-2">
            <Card className="rounded-2xl">
              <Space direction="vertical" size="small">
                <div>
                  <p>Mã thu dẻ</p>
                  <Text className="text-base font-bold">
                    {purchaseOrderData?.id || '-'}
                  </Text>
                </div>
                <div>
                  <p>Mã PO</p>
                  <Text className="text-base font-bold">
                    {purchaseOrderData?.poId || '-'}
                  </Text>
                </div>
                {/* <div>
                  <p>Số MIGO (Nhập / Xuất)</p>
                  <Text className="text-base font-bold">
                    {migoNumber || '- / _'}
                  </Text>
                  <div className="mt-2">
                    <Button
                      title="Xem chi tiết"
                      handleOnclick={() => setShowMigoDetail(true)}
                    />
                  </div>
                </div> */}
                <div>
                  <p>Bảng tổng hợp thanh toán</p>
                  <Text className="text-base font-bold">-</Text>
                </div>
              </Space>
            </Card>

            <Card className="rounded-2xl my-4">
              <Flex vertical gap={8}>
                {priceDetails.map((price, index) => (
                  <Row key={index} align="middle" justify="space-between">
                    <Col>
                      <Text>{price.label}</Text>
                    </Col>
                    <Col>
                      <Text className={price.className}>
                        {handleRenderValue(price.value)}
                      </Text>
                    </Col>
                  </Row>
                ))}
              </Flex>
            </Card>

            <Card className="rounded-2xl my-4">
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>TL Q10 mua</Text>
                </Col>
                <Col>
                  <Text>
                    {/* {purchaseOrderData?.totalQ10Buy */}
                    {purchaseOrderData?.totalQ10Buy !== null &&
                    purchaseOrderData?.totalQ10Buy !== undefined
                      ? formatCurrency({
                          value: Number(
                            Number(purchaseOrderData?.totalQ10Buy).toFixed(4),
                          ),
                          format: 4,
                        })
                      : '-'}
                  </Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>TL Q10 bán</Text>
                </Col>
                <Col>
                  <Text>
                    {purchaseOrderData?.totalQ10Sell !== null &&
                    purchaseOrderData?.totalQ10Sell !== undefined
                      ? formatCurrency({
                          value: purchaseOrderData?.totalQ10Sell,
                          format: 3,
                        })
                      : '-'}
                  </Text>
                </Col>
              </Row>
              <Divider className="!my-3" />
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Thành tiền</Text>
                </Col>
                <Col>
                  <Text className="text-base font-bold">
                    {handleRenderValue(formatNumber(finalPrice || 0))}
                  </Text>
                </Col>
              </Row>
            </Card>

            <Card className="rounded-2xl my-4">
              <Form form={noteForm}>
                <FormItem name="note" className="!mb-0">
                  <TextArea
                    placeholder="Ghi chú"
                    disabled={isAccountantDisableEdit}
                    // disabled={
                    //   !user?.isAccountant ||
                    //   !!purchaseOrderData?.parentId ||
                    //   purchaseOrderData?.statusId === 'OR02_02'
                    // }
                    onChange={handleUpdatePurchaseOrderDebounced}
                  />
                </FormItem>
              </Form>
            </Card>

            <Card className="rounded-2xl my-4">
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Ngày tạo</Text>
                </Col>
                <Col>
                  <Text>
                    {purchaseOrderData?.createDate
                      ? dayjs(purchaseOrderData?.createDate).format(
                          'DD/MM/YYYY HH:mm:ss',
                        )
                      : '-'}
                  </Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Người tạo</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.tcreateUser?.fullName || '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Ngày cập nhật</Text>
                </Col>
                <Col>
                  <Text>
                    {purchaseOrderData?.modifyDate
                      ? dayjs(purchaseOrderData?.modifyDate).format(
                          'DD/MM/YYYY HH:mm:ss',
                        )
                      : '-'}
                  </Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Người cập nhật</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.tmodifyUser?.fullName || '-'}</Text>
                </Col>
              </Row>
            </Card>
            <Card className="rounded-2xl">
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Nhập kho (Migo)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.matDoc ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Năm nhập kho (Migo)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.matYear ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Hoá đơn (Miro)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.ivDoc ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Năm hoá đơn (Miro)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.reivYear ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Trạng thái hoá đơn</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.ivStatus ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col span={24}>
                  <Text
                    style={{
                      color: '#038F00',
                      textAlign: 'right',
                      display: 'block',
                    }}
                  >
                    Chưa thanh toán
                  </Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Hoá đơn huỷ (Miro)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.reivDoc ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Năm huỷ (Miro)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.ivYear ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Nhập kho huỷ (Migo)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.rematDoc ?? '-'}</Text>
                </Col>
              </Row>
              <Row justify="space-between" align="middle">
                <Col>
                  <Text>Năm huỷ nhập kho (Migo)</Text>
                </Col>
                <Col>
                  <Text>{purchaseOrderData?.rematYear ?? '-'}</Text>
                </Col>
              </Row>
            </Card>
          </div>

          <div className="col-span-8 w-full">
            <Form form={purchaseInvoiceForm} layout="vertical">
              <Card className="rounded-2xl" classNames={{ body: '!p-3' }}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="purchaseType"
                      label="Loại thu dẻ"
                      rules={[{ required: true, message: 'Chọn loại thu dẻ' }]}
                    >
                      <SelectForm
                        options={typePurchase}
                        placeholder="Chọn loại thu dẻ"
                        // disabled={isAccountantDisableEdit}
                        disabled={
                          !!purchaseOrderData?.parentId ||
                          !(
                            user?.isAccountant ||
                            user?.isStorekeeper ||
                            user?.isKTD
                          ) ||
                          purchaseOrderData?.statusId === 'OR02_02'
                        }
                        onSelect={handleUpdatePurchaseOrder}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="documentType"
                      label="Loại chứng từ"
                      rules={[
                        { required: true, message: 'Chọn loại chứng từ' },
                      ]}
                    >
                      <SelectForm
                        placeholder="Chọn chứng từ"
                        options={typeOfDocPurchase}
                        // disabled={isAccountantDisableEdit}
                        disabled={
                          !!purchaseOrderData?.parentId ||
                          !(
                            user?.isAccountant ||
                            user?.isStorekeeper ||
                            user?.isKTD
                          ) ||
                          purchaseOrderData?.statusId === 'OR02_02'
                        }
                        onSelect={handleUpdatePurchaseOrder}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="policyType"
                      label="Chính sách"
                      rules={[{ required: true, message: 'Chọn chính sách' }]}
                    >
                      <SelectForm
                        // defaultValue={'PY100_01'}
                        placeholder="Chọn chính sách"
                        options={typePolicyPurchase}
                        // disabled={isAccountantDisableEdit}
                        disabled={
                          !!purchaseOrderData?.parentId ||
                          !(
                            user?.isAccountant ||
                            user?.isStorekeeper ||
                            user?.isKTD
                          ) ||
                          purchaseOrderData?.statusId === 'OR02_02'
                        }
                        onSelect={handleUpdatePurchaseOrder}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="unit"
                      label="Đơn vị tính"
                      rules={[{ required: true, message: 'Chọn đơn vị tính' }]}
                    >
                      <SelectForm
                        options={unitPurchase}
                        placeholder="Chọn đơn vị tính"
                        // disabled={isAccountantDisableEdit}
                        disabled={
                          !!purchaseOrderData?.parentId ||
                          !(
                            user?.isAccountant ||
                            user?.isStorekeeper ||
                            user?.isKTD
                          ) ||
                          purchaseOrderData?.statusId === 'OR02_02'
                        }
                        onSelect={handleUpdatePurchaseOrder}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} hidden={purchaseType !== '800'}>
                    <Form.Item
                      name="q10Surplus"
                      label="Biên độ"
                      rules={[{ required: true, message: 'Nhập biên độ' }]}
                    >
                      <InputForm
                        suffix="Chỉ"
                        allowClear={false}
                        placeholder="Nhập biên độ"
                        // disabled={isAccountantDisableEdit}
                        disabled={
                          !!purchaseOrderData?.parentId ||
                          !(
                            user?.isAccountant ||
                            user?.isStorekeeper ||
                            user?.isKTD
                          ) ||
                          purchaseOrderData?.statusId === 'OR02_02'
                        }
                        onChange={handleUpdatePurchaseOrderDebounced}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} hidden={purchaseType !== '800'}>
                    <Form.Item
                      name="orderIds"
                      label="Bảng kê"
                      // rules={[
                      //   {
                      //     required: purchaseType === '800',
                      //     message: 'Chọn bảng kê',
                      //   },
                      // ]}
                    >
                      <SelectForm
                        mode="multiple"
                        options={filteredOptions}
                        placeholder="Chọn bảng kê"
                        disabled={isAccountantDisableEdit}
                        // disabled={
                        //   !user?.isAccountant ||
                        //   !!purchaseOrderData?.parentId ||
                        //   purchaseOrderData?.statusId === 'OR02_02'
                        // }
                        onSelect={handleUpdatePurchaseOrder}
                        onDeselect={handleUpdatePurchaseOrder}
                        onChange={(value) => {
                          if (!value?.length) {
                            setFilteredOptions(orderTempId);
                            return;
                          }

                          const formattedValue = value?.[0];
                          const selectedItem = orderTempId.find(
                            (item) => item.id === formattedValue,
                          );

                          if (selectedItem) {
                            const filtered = orderTempId.filter(
                              (item) =>
                                item.marketGoldPrice ===
                                selectedItem.marketGoldPrice,
                            );

                            setFilteredOptions(filtered);
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Card className="rounded-2xl my-4" classNames={{ body: '!p-3' }}>
                <Collapse
                  ghost
                  className="w-full [&>.ant-collapse-item>.ant-collapse-content>.ant-collapse-content-box]:!py-0"
                  defaultActiveKey={['1']}
                  expandIconPosition="end"
                >
                  <Panel
                    key="1"
                    className="w-full"
                    header={<h4 className="text-lg font-bold">Người bán</h4>}
                  >
                    <Row gutter={24}>
                      <FormItem name="typeCustomer" className="mb-1">
                        <Radio.Group
                          name="radiogroup"
                          className="pl-3"
                          onChange={() => handleUpdatePurchaseOrder({})}
                        >
                          {/* {typeCustomer &&
                          typeCustomer.map((c) => (
                            <Radio key={c.id} value={c.id}>
                              {c.name}
                            </Radio>
                          ))} */}
                          <Radio
                            key="CT100_02"
                            value="CT100_02"
                            disabled={isAccountantDisableEdit}
                            // disabled={
                            //   !user?.isAccountant ||
                            //   !!purchaseOrderData?.parentId ||
                            //   purchaseOrderData?.statusId === 'OR02_02'
                            // }
                          >
                            Khách hàng cũ
                          </Radio>
                          <Radio
                            key="CT100_01"
                            value="CT100_01"
                            disabled={isAccountantDisableEdit}
                            // disabled={
                            //   !user?.isAccountant ||
                            //   !!purchaseOrderData?.parentId ||
                            //   purchaseOrderData?.statusId === 'OR02_02'
                            // }
                          >
                            Khách hàng mới
                          </Radio>
                        </Radio.Group>
                      </FormItem>
                    </Row>
                    <Row gutter={24}>
                      <Col span={24}>
                        <FormItem
                          name="purchaseCustomerId"
                          rules={[
                            { required: true, message: 'Chọn khách hàng' },
                          ]}
                        >
                          <SelectForm
                            disabled={isAccountantDisableEdit}
                            // disabled={
                            //   !user?.isAccountant ||
                            //   !!purchaseOrderData?.parentId ||
                            //   purchaseOrderData?.statusId === 'OR02_02'
                            // }
                            options={customerData?.map((customer) => ({
                              value: customer?.id,
                              label: `${customer?.sapCustomerId} - ${customer?.storeName}`,
                            }))}
                            onSelect={handlePurchaseCustomerSelect}
                          />
                        </FormItem>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Text strong>
                          {selectedPurchaseCustomer?.storeName}
                        </Text>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={16}>
                        <Text strong>Tên doanh nghiệp: </Text>
                        <Text>{selectedPurchaseCustomer?.storeName}</Text>
                      </Col>
                      <Col span={8}>
                        <Text strong>Mã số thuế: </Text>
                        <Text>{selectedPurchaseCustomer?.taxId}</Text>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Text strong>Địa chỉ: </Text>
                        <Text>{selectedPurchaseCustomer?.address}</Text>
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>
              </Card>
            </Form>
            <Card className="rounded-2xl" classNames={{ body: '!p-3' }}>
              <TableAddPurchaseInvoice
                data={tableData}
                purchaseOrderData={purchaseOrderData}
                editIndex={editIndex}
                setEditIndex={setEditIndex}
                setTableData={setTableData}
                onAdd={handleAddPurchaseInvoiceItem}
                onEdit={handleEditPurchaseInvoiceItem}
                onDelete={handleDelPurchaseInvoiceItem}
                onSave={onSave}
                migoList={processData}
                lastMigoStatus={lastItem?.status}
                lastMigoType={lastItem?.processType}
              />
            </Card>
          </div>
        </div>

        <Modal
          width={1200}
          title="Khách hàng"
          closeIcon={null}
          open={isOpenCustomerModal}
          footer={
            <Flex align="center" justify="end" gap={4}>
              <Button
                title="Hủy"
                handleOnclick={() => navigate(path.PURCHASE_INVOICE)}
              />
              <Button
                fill
                title="Xác nhận"
                handleOnclick={() => customerForm.submit()}
              />
            </Flex>
          }
        >
          <Form
            layout="vertical"
            form={customerForm}
            onFinish={handleSubmitModal}
          >
            <Row gutter={{ xs: 8, sm: 14 }}>
              <Col span={16}>
                <Form.Item
                  label="Mã KH"
                  name="customerId"
                  rules={[
                    { required: true, message: 'Vui lòng chọn khách hàng' },
                  ]}
                >
                  <LazySelectForm
                    className="mb-2"
                    data={customers}
                    placeholder="Chọn Khách hàng"
                    loading={isGetCustomersPending}
                    onSelect={handleCustomerSelect}
                    onSelectScrollChange={handleScrollCustomersChange}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={colSpan}>
              <Form.Item label="Tên KH" name="storeName">
                <InputForm className="mb-2" readOnly placeholder="Tên KH" />
              </Form.Item>
            </Col> */}
              <Col span={colSpan}>
                <Form.Item label="Loại" name="trankName">
                  <InputForm className="mb-2" readOnly placeholder="Loại" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 14 }}>
              <Col span={colSpan}>
                <Form.Item name="taxId" label="MST">
                  <InputForm className="mb-2" readOnly placeholder="MST" />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="mainCustomerId" label="Người đại diện">
                  <InputForm
                    className="mb-2"
                    readOnly
                    placeholder="Người đại diện"
                  />
                </Form.Item>
              </Col>
              <Col span={colSpan}>
                <Form.Item name="phone" label="SDT">
                  <InputForm className="mb-2" readOnly placeholder="SDT" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 14 }}>
              <Col span={24}>
                <Form.Item
                  name="address"
                  label="Địa chỉ"
                  labelCol={{ span: 24 }}
                >
                  <InputForm className="mb-2" readOnly placeholder="Địa chỉ" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Modal
          title="Thương lượng giá bóng"
          open={isOpenPriceNegotiation}
          className="min-w-[600px]"
          onCancel={handleCancelPriceNegotation}
          footer={
            <Flex align="center" justify="end" gap={4}>
              <Button
                type="button"
                title="Quay lại"
                handleOnclick={handleCancelPriceNegotation}
              />
              <Button
                fill
                title="Gửi duyệt"
                handleOnclick={() => priceNegotationForm.submit()}
              />
            </Flex>
          }
        >
          <Form
            layout="vertical"
            form={priceNegotationForm}
            onFinish={handlePriceNegotation}
          >
            <Row gutter={{ xs: 8, sm: 14 }}>
              <Col span={12}>
                <FormItem
                  label="Giá bóng hiện tại"
                  name="currentMarketGoldPrice"
                  className="mb-1"
                >
                  <InputForm readOnly placeholder="Nhập giá bóng" />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  className="mb-1"
                  label="Giá bóng thỏa thuận"
                  name="marketGoldPriceNegotation"
                  rules={[
                    {
                      required: true,
                      message: 'Vui lòng nhập giá bóng thỏa thuận',
                    },
                  ]}
                >
                  <InputForm
                    placeholder="Nhập giá bóng"
                    onChange={handleMarketGoldPriceChange}
                  />
                </FormItem>
              </Col>
            </Row>
            <FormItem name="note" label="Ghi chú" className="mb-1">
              <TextArea placeholder="Nhập ghi chú" />
            </FormItem>
            <FormItem
              className="mb-1"
              name="usePolicyPrice"
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox>Tính theo chính sách</Checkbox>
            </FormItem>
          </Form>
        </Modal>
      </Layout>
      <MigoDetailModal
        visible={showMigoDetail}
        onClose={() => setShowMigoDetail(false)}
        purchaseOrderId={purchaseOrderData?.id || ''}
      />
    </Spin>
  );
};

export default AddPurchaseInvoice;
